import React from "react";
import { useContent } from '../contexts/ContentContext';
import '../assets/styles/AIWork.scss';

function AIWork() {
  const { content } = useContent();
  const aiWorks = content.aiWork;

  return (
    <div className="ai-work-container" id="ai-work">
      <div className="items-container">
        <div className="section-code-header">
          <span className="code-keyword">const</span>
          <span className="code-variable">aiWork</span>
          <span className="code-operator">=</span>
          <span className="code-bracket">[</span>
        </div>
        <p className="section-comment">// AI & machine learning solutions with production-grade systems</p>
        <div className="ai-work-grid">
          {aiWorks.map((work, index) => (
            <div key={index} className="ai-work-card">
              <div className="ai-work-header">
                <div>
                  <span className="code-token">model</span> <span className="ai-work-title">{work.title}</span>
                </div>
                <span className={`ai-work-status ${work.status.toLowerCase()}`}>{work.status}</span>
              </div>
              <p className="ai-work-description">{work.description}</p>
              <div className="ai-work-technologies">
                <h4>Technologies Used</h4>
                <div className="system-tags">
                  {work.technologies.map((tech, idx) => (
                    <span key={idx} className="code-tag">{tech}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="section-code-footer">];</div>
      </div>
    </div>
  );
}

export default AIWork;